export function formatCivilDay(ymd) {
  const s = String(ymd || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(`${s}T12:00:00.000Z`);
  return d.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  });
}

export function formatWhen(item) {
  if (!item?.date) return '';
  const day = formatCivilDay(item.date);
  return item.startTime ? `${day} · ${item.startTime}` : day;
}
